import { type FC } from 'react';

import { Link } from 'react-router-dom';

import type { IEquipmentComponent } from '@shared/types';

import styles from './EquipmentComposition.module.css';

interface EquipmentCompositionProps {
  id: string;
  items: readonly IEquipmentComponent[];
  basePath: string;
}

/** Обзор зоны описывает её объекты; техника упражнений остаётся в карточках снарядов. */
export const EquipmentComposition: FC<EquipmentCompositionProps> = ({ id, items, basePath }) => (
  <section className={styles.root} aria-labelledby={`composition-${id}`}>
    <h2 className={styles.title} id={`composition-${id}`}>
      Состав зоны
    </h2>
    <ul className={styles.list} role="list">
      {items.map((item) => (
        <li className={styles.item} key={item.title}>
          <h3 className={styles.itemTitle}>
            {item.itemId ? (
              <Link className={styles.link} to={`${basePath}/${item.itemId}`}>
                {item.title}
              </Link>
            ) : (
              item.title
            )}
          </h3>
          <p className={styles.description}>{item.description}</p>
        </li>
      ))}
    </ul>
  </section>
);
